"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SafelyQuicklySignRequest = void 0;
var SafelyQuicklySignRequest = /** @class */ (function () {
    function SafelyQuicklySignRequest() {
    }
    return SafelyQuicklySignRequest;
}());
exports.SafelyQuicklySignRequest = SafelyQuicklySignRequest;
;
//# sourceMappingURL=safelyQuicklySign.request.js.map